import * as React from 'react';
import { ButtonSecondary } from 'ui/common/button';
import { ElementLoader, EditableComponentProps, ComplexValue } from 'ui';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { SearchResultList } from 'app/area/case/components/search-external-provider/search-result-list';
import { MdOutlineAutoAwesome } from 'react-icons/md';

import styles from './search-external-provider.scss';
import { 
  SetValuesFromResultType, 
  SearchExternalProviderType, ClearResultsType } from 'app/area/case/features/search-external-provider/types';
import { SearchExternalResultValue } from 'app/area/case/types-store';
import { useCallback } from 'react';
import { ModalSize } from 'app/components/constants';

export interface SearchExternalProviderProps extends EditableComponentProps<ComplexValue<string>>, OpenStateInjectedProps {
  searchExternalProvider: SearchExternalProviderType;
  clearResults: ClearResultsType;
  setValuesFromResult: SetValuesFromResultType;
  fetching?: boolean;
  canSearch?: boolean;
  results?: SearchExternalResultValue[][];
  textDialogHeader?: string;
  textConfirmSelection?: string;
  textFailedToMapCodeValue?: string;
  textItemNotFound?: string;
  error?: string;
  showAIChatIcon?: boolean;
}

const SearchExternalProviderComponent = ({
  componentId, className, textDialogHeader, textItemNotFound,
  textConfirmSelection, textFailedToMapCodeValue, label, fetching, 
  isOpen, results, canSearch, error, clearResults, searchExternalProvider,
  open, close, setValuesFromResult, readOnly, showAIChatIcon
}: SearchExternalProviderProps) => {

  const onClick = useCallback(() => {
    searchExternalProvider && searchExternalProvider();
    open();
  }, [searchExternalProvider, open]);

  const onCloseDialog = useCallback(() => {
    close(clearResults);
  }, [close, clearResults]);

  const setValues = useCallback((values: SearchExternalResultValue[]) => {
    setValuesFromResult && setValuesFromResult(values);
    close(clearResults);
  }, [setValuesFromResult, close]);

  const { button, buttonWrapper } = styles;
  
  const modalTitle = showAIChatIcon ? (
    <span>
      {<MdOutlineAutoAwesome className={styles.aiChatIconWithTitle} />} {textDialogHeader}
    </span>
  ) : (
    textDialogHeader
  );  

  return (
    !readOnly && 
      <div id={componentId} className={`form-group col-lg-4 col-xl-4 ${styles.searchExternalProvider} ${className || ''}`}>
        <div className={`input-wrapper ${buttonWrapper}`}>
          <ButtonSecondary 
            onClick={onClick}
            classNames={button}
            disabled={fetching || !canSearch}>
            {showAIChatIcon && <MdOutlineAutoAwesome className={styles.aiChatIcon} />}
            {label && label.text}
          </ButtonSecondary>
          {isOpen && (
            <ModalWrapper 
              headerTitle={modalTitle}
              onClose={onCloseDialog} 
              size={ModalSize.large}>
              {error && <div className={styles.errorMessage}>{error}</div>}
              <div>
                {fetching ? <ElementLoader /> :
                  (!error && results && <SearchResultList
                    results={results}
                    setValuesFromResult={setValues}
                    textConfirmSelection={textConfirmSelection}
                    textFailedToMapCodeValue={textFailedToMapCodeValue}
                    textItemNotFound={textItemNotFound}
                    onChange={undefined}
                    componentId={componentId}
                    className={className}
                  />)
                }
              </div>
            </ModalWrapper>
          )}
        </div>
      </div>
  );
};

export const SearchExternalProvider = withOpenState(true)(SearchExternalProviderComponent);
